module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEXYtyf80RZ+hFUAOJOsFzjOESbOESbE3bqEAAAAB3RSTlP+///////UPYIePwAAADFJREFUeAFjYSAZsAiSroWgilEto1pGtYxqGdUyqkVwtEoa1TKqZTSLDVUto1pG8wsAWlcBcyeUmCEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/co.png
// module id = pA5D
// module chunks = 0